var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"imageMarker",staticClass:"imageMarker alibabaPuHuiTiFontFamily",style:({'background-image':'url(' + _vm.imageMarkerInfo.thumb + ')'}),on:{"click":_vm.clickImageMarker}},[_c('p',{staticClass:"imageMarker-title"},[_vm._v(_vm._s(_vm.imageMarkerInfo.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }